import http from "@/http-common";

class NewsinfoDataService {
  getNews(data: any): Promise<any> {
    return http.api.post("/getNews/", data);
  }
  getRowNews(data: any): Promise<any> {
    return http.api.post("/getRowNews/", data);
  }
  getOldNews(data: any): Promise<any> {
    return http.api.post("/getOldNews/", data);
  }
  getEditNews(data: any): Promise<any> {
    return http.api.post("/getEditNews/", data);
  }
  getImportanceList(): Promise<any> {
    return http.api.post("/getImportanceList/");
  }
  addorUpdateNews(data: any): Promise<any> {
    return http.api.post("/addorUpdateNews/", data);
  }
  deleteNews(data: any): Promise<any> {
    return http.api.post("/deleteNews/", data);
  }
}
export default new NewsinfoDataService();
